<bit-header></bit-header>

<main class="bg-new-dark w-full pt-8 px-10 lg:py-[130px]">
    <div class="container flex flex-col lg:flex-row items-center justify-center lg:gap-28 lg:px-10">

        <div class="flex flex-col">
            <h1 class="font-extrabold text-[24px] lg:text-[42px] flex items-center gap-9 lg:gap-2 self-end"><span> 
                    ارز
                    دیجیتال</span> <span class="text-primary text-[40px] lg:text-[64px]">Bit.ir</span></h1>
            <div class="flex justify-end pl-2 lg:pl-[18px] mt-[-14px] lg:mt-[-22px]">
                <div
                    class="flex flex-col justify-end text-left font-medium lg:font-bold text-base lg:text-xl leading-[26px] pt-[5px] lg:pt-8 pl-1">
                    <p>Be Fast</p>
                    <p>Instant Deposit & Withdraw</p>
                    <p>Trade Secure</p>
                </div>
                <svg width="137" height="102" viewBox="0 0 137 102" fill="none" xmlns="http://www.w3.org/2000/svg"
                    class="hidden lg:inline-block">
                    <rect width="2" height="42" fill="#F3C40A" />
                    <rect x="34" width="2" height="71" fill="#F3C40A" />
                    <rect x="59" width="2" height="102" fill="#F3C40A" />
                    <rect x="137" y="41" width="2.00001" height="137" transform="rotate(90 137 41)" fill="#F3C40A" />
                    <rect x="137" y="69" width="2" height="103" transform="rotate(90 137 69)" fill="#F3C40A" />
                    <rect x="137" y="100" width="2" height="78" transform="rotate(90 137 100)" fill="#F3C40A" />
                </svg>

                <svg width="107" height="66" viewBox="0 0 107 66" fill="none" xmlns="http://www.w3.org/2000/svg"
                    class="inline-block lg:hidden">
                    <rect width="2" height="24" fill="#F3C40A" />
                    <rect x="25" width="2" height="44" fill="#F3C40A" />
                    <rect x="43" width="2" height="66" fill="#F3C40A" />
                    <rect x="107" y="22" width="2" height="107" transform="rotate(90 107 22)" fill="#F3C40A" />
                    <rect x="107" y="42" width="2" height="82" transform="rotate(90 107 42)" fill="#F3C40A" />
                    <rect x="107" y="64" width="2" height="64" transform="rotate(90 107 64)" fill="#F3C40A" />
                </svg>


            </div>

            <div class="flex items-center mt-7">
                <input
                    class="bg-transparent py-2 grow lg:grow-0 lg:py-[14px] px-[10px] text-base lg:text-xl lg:min-w-[320px] focus-visible:outline-none border-2 border-solid border-[#262626] rounded-tr-md rounded-br-md"
                    type="text" placeholder="ایمیل خود را وارد کنید" [(ngModel)]="userEmail">
                <a [href]="'https://app.bit.ir/sign-up' + (userEmail ? ('?email=' + userEmail) : '') "
                    class="bg-primary hover:bg-primary-dark transition-colors py-2 text-base lg:py-[16px] -mr-1 lg:text-xl font-semibold text-new-dark px-4 lg:px-11 rounded-bl-md rounded-tl-md border border-solid border-primary lg:border-none">ثبت
                    نام</a>
            </div>

            <h2 class="mt-5 font-semibold text-lg">در کمتر از 10 دقیقه احراز و اولین خرید خود را انجام دهید.</h2>
        </div>

        <img src="assets/images/landing-hero.gif" alt="">

        <!-- <video class="third-pc-animation" autoplay loop playsinline width="936" height="253" muted
            style="visibility: visible;" src="assets/images/landing/landing-hero.webm"></video> -->

    </div>
</main>

<section class="bg-[#111111] py-7 lg:py-10">
    <div class="container px-5 lg:px-20 ">
        <div class="grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-1" #anime>
            <ng-container *ngIf="shownMarkets; else skeleton">
                <div class="text-right flex flex-col gap-2 min-h-[114px] lg:min-h-fit" id="coin-item"
                    *ngFor="let market of shownMarkets">
                    <span class="text-base lg:text-xl text-[#999999] font-semibold">{{ market.name }}</span>
                    <span class="text-xl lg:text-2xl font-bold text-white">{{market.lastPrice / 10 | number}}
                        تومان</span>
                    <bit-percentage [value]="market.percent"></bit-percentage>
                </div>
            </ng-container>
        </div>
    </div>
</section>

<section class="bg-new-dark py-7 px-5">
    <div class="container grid grid-cols-2 lg:grid-cols-4 gap-[18px]">
        <div
            class="group hover:scale-105 transition-all flex p-5 lg:p-7 bg-[#111111] flex-col lg:flex-row items-center justify-between gap-3 rounded-[10px]">
            <h3 class="text-2xl text-white flex flex-col ">
                تا 30%
                <span class="text-base">درآمد از
                    دعوت دوستان</span>
            </h3>
            <img src="assets/images/landing/money-bag.svg" alt="Money Bag"
                class="self-end lg:self-auto h-[80px] lg:h-[114px] group-hover:scale-125 transition-all">
        </div>
        <div
            class="group hover:scale-105 transition-all flex p-5 lg:p-7 bg-[#111111] flex-col lg:flex-row items-center justify-between  gap-3 rounded-[10px]">
            <h3 class="text-2xl text-white flex flex-col">
                بیش از 150 <span class="text-base">بازار متنوع</span>
            </h3>
            <img src="assets/images/landing/coins.svg" alt="Markets"
                class="self-end lg:self-auto h-[80px] lg:h-[114px] group-hover:scale-125 transition-all">
        </div>
        <div
            class="group hover:scale-105 transition-all flex p-5 lg:p-7 bg-[#111111] flex-col lg:flex-row items-center justify-between  gap-3 rounded-[10px]">
            <h3 class="text-2xl text-white flex flex-col">
                کمپین‌های جذاب <span class="text-base">بی‌نهایت تتر</span>
            </h3>
            <img src="assets/images/landing/campaign.svg" alt="campaign"
                class="self-end lg:self-auto h-[80px] lg:h-[114px] group-hover:scale-125 transition-all">
        </div>
        <div
            class="group hover:scale-105 transition-all flex p-5 lg:p-7 bg-[#111111] flex-col lg:flex-row items-center justify-between  gap-3 rounded-[10px]">
            <h3 class="text-2xl text-white flex flex-col">
                پشتیبانی <span class="text-base">24 ساعته <br>
                    7 روز هفته</span>
            </h3>
            <img src="assets/images/landing/support.svg" alt="Support"
                class="self-end lg:self-auto h-[80px] lg:h-[114px] group-hover:scale-125 transition-all">
        </div>
    </div>
</section>

<bit-market-list></bit-market-list>

<section class="bg-new-dark py-7 lg:py-16 px-12">
    <div
        class="container flex flex-col lg:flex-row items-center gap-4 text-3xl font-extrabold text-center lg:justify-center lg:gap-[200px]">
        <div class="flex flex-col gap-4 lg:text-right">
            <span>خرید و فروش</span>
            <span>در هر زمان و هر مکان با</span>
            <span class="text-primary text-4xl font-black">  Bit.ir</span>

            <div class="lg:flex gap-3 mt-3 hidden">
                <a href="https://cafebazaar.ir/app/ir.bit.app.twa" target="_blank">
                    <img class="w-[200px] rounded-lg" src="assets/images/landing/qr-code.png" alt="QR code to download app">
                </a>
                <p class="font-semibold text-[#999999] text-2xl self-center">برای دانلود اپلیکیشن <br>
                    کد را اسکن کنید.</p>
            </div>
        </div>

        <img src="assets/images/landing/phone.webp" alt="Phone" class="h-[300px] lg:h-[600px]">

        <div class="flex items-center gap-8 lg:hidden">
            <img src="assets/images/landing/app-store.png" alt="App Store">
            <a href="https://cafebazaar.ir/app/ir.bit.app.twa">
                <img src="assets/images/landing/cafebazaar.png" alt="Cafe Bazaar Download Link" class="max-w-[140px]">
            </a>
        </div>
    </div>
</section>

<section class="bg-black text-white py-7" id="tutorial">
    <div class="container px-10 lg:px-0">
        <div class="flex flex-col text-center gap-3 mb-2">
            <p class="text-3xl lg:text-4xl font-extrabold">با شما در هر قدم</p>
            <p class="text-2xl lg:text-3xl font-bold">یاد بگیر، معامله کن، سود ببر <br>
                در چند مرحله به معاملات سودده برسید.</p>
        </div>

        <img class="mx-auto lg:hidden" src="assets/images/landing/mobile-tutorial.gif" alt="Tutorial">

        <img src="assets/images/landing/desktop-tutorial.gif" alt="Tutorial Gif" class="w-full mx-auto hidden lg:block">
    </div>
</section>


<bit-footer></bit-footer>


<ng-template #skeleton>
    <!-- <div class="flex"> -->
    <bit-skeleton [height]="80" [width]="100" [widthUnit]="'%'"></bit-skeleton>
    <bit-skeleton [height]="80" [width]="100" [widthUnit]="'%'"></bit-skeleton>
    <bit-skeleton [height]="80" [width]="100" [widthUnit]="'%'"></bit-skeleton>
    <bit-skeleton [height]="80" [width]="100" [widthUnit]="'%'"></bit-skeleton>
    <!-- </div> -->
</ng-template>